// Import the functions you need from the SDKs you need
// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDKJDik2tj5bbtUf8kd5xjkPORRz8SMel0",
  authDomain: "didaskia-87fd1.firebaseapp.com",
  projectId: "didaskia-87fd1",
  storageBucket: "didaskia-87fd1.firebasestorage.app",
  messagingSenderId: "944132005712",
  appId: "1:944132005712:web:646fc9d57fe978d4f0d655",
  measurementId: "G-6S2M3R609X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// ⚠️ AQUÍ ESTÁ LO IMPORTANTE → los exports
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();